import { useDispatch } from "react-redux";
import { updateFilter, resetFilters } from "..";

export const useCampaignRouletteFilterActions = () => {
  const dispatch = useDispatch();

  return {
    updateFilter: (data: { key: string; value: unknown }) =>
      dispatch(updateFilter(data)),
    resetFilters: () => dispatch(resetFilters()),
  };
};
